(() => {
    if (window.__supercartHooked__) return;
    window.__supercartHooked__ = true;

    const fetchOriginal = window.fetch;

    window.fetch = function (...args) {
        const url = args[0];
        return fetchOriginal(...args)
            .then((res) => {
                if (typeof url === 'string' && (
                    url.includes('/cart/change.js') || url.includes('/cart/update.js')
                )) {
                    setTimeout(syncCartCount, 500);
                }
                return res;
            })
            .catch(() => {
                // Silently fail in production — optional: send to logging service
            });
    };

    function syncCartCount() {
        fetch('/cart.json')
            .then((res) => res.json())
            .then((data) => {
                document.querySelectorAll('.header__cart-count').forEach((el) => {
                    el.textContent = data.item_count;
                    el.style.visibility = 'visible';
                    el.classList.remove('hidden', 'opacity-0', 'invisible');
                });
            })
            .catch(() => {
                // Optional: silent fail or log to monitoring
            });
    }
})();
